import { render, staticRenderFns } from "./healthyProgramme.vue?vue&type=template&id=55de3718&"
import script from "./healthyProgramme.vue?vue&type=script&lang=js&"
export * from "./healthyProgramme.vue?vue&type=script&lang=js&"
import style0 from "./healthyProgramme.vue?vue&type=style&index=0&id=55de3718&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports